// @core/api/endpoints/project/create_label.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateLabelRequest,
  LabelResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Create label
 * Creates a new color-coded label for the project. Labels can be applied to items for categorization and filtering.
 */
export async function CreateLabel(
  project_id: string,
  data: CreateLabelRequest,
  options?: RequestOptions
): Promise<LabelResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/labels`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.post<LabelResponse>(requestPath, data, requestOptions);
}
